import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [authGuard],
  },
  {
    path: '',
    // 'home' est une page vide : hors production on ouvre directement une vraie page,
    // accessible via la barre d'onglets de dev.
    redirectTo: environment.production ? 'home' : 'suivi',
    pathMatch: 'full',
  },
  {
    path: 'suivi',
    loadChildren: () => import('./pages/suivi/suivi.module').then( m => m.SuiviPageModule),
    canActivate: [authGuard],
  },
  {
    path: 'resultats',
    loadChildren: () => import('./pages/resultats/resultats.module').then( m => m.ResultatsPageModule),
    canActivate: [authGuard],
  },{
    path: 'assignation',
    loadChildren: () => import('./pages/assignation/assignation.module').then( m => m.AssignationPageModule),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./pages/unauthorized/unauthorized.module').then( m => m.UnauthorizedPageModule)
  },
  {
    path: 'notyetavailable',
    loadChildren: () => import('./pages/notyetavailable/notyetavailable.module').then( m => m.NotyetavailablePageModule)
  },
  {
    path: 'recommandations',
    loadChildren: () => import('./pages/recommandations/recommandations.module').then( m => m.RecommandationsPageModule),
    canActivate: [authGuard],
  },
  {
    path: 'assistant-enseignant',
    loadChildren: () => import('./pages/assistant-enseignant/assistant-enseignant.module').then( m => m.AssistantEnseignantPageModule),
    canActivate: [authGuard],
  },
];
